const LOGOS = ["HYPEBEAST", "COMPLEX", "HIGHSNOBIETY", "DAZED", "VOGUE", "i-D"];

export default function PressStrip() {
  return (
    <section data-testid="press-strip" className="border-b border-white/15 bg-ink py-6 sm:py-8">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 text-ash text-[10px] tracking-[0.4em] font-mono uppercase mb-4">
          <span className="w-6 h-px bg-ash" />
          AS SEEN IN
          <span className="w-6 h-px bg-ash" />
        </div>
        <div className="flex flex-wrap items-center justify-between gap-y-4">
          {LOGOS.map((logo, i) => (
            <span
              key={logo}
              className={`font-anton text-bone uppercase tracking-tighter text-2xl sm:text-3xl opacity-60 hover:opacity-100 hover:text-blood transition-colors ${
                i % 2 === 0 ? "italic" : ""
              }`}
            >
              {logo}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
